export default __webpack_public_path__ + "static/media/gold.a76eaa26.png";